import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import PropTypes from 'prop-types';

const propTypes = {
  isProcessing: PropTypes.bool,
  onCancel: PropTypes.func,
  isUpdate: PropTypes.bool,
  reverse: PropTypes.bool,
};
const defaultProps = {
  isProcessing: false,
  onCancel: () => null,
  isUpdate: false,
  reverse: false,
};

export function ActionButtons({ isProcessing, onCancel, isUpdate, reverse }) {
  const [render, setRender] = useState(0);

  useEffect(() => {
    setRender(false);
    if (render) {
      setTimeout(() => setRender(true), 100);
    }
  }, [isProcessing, isUpdate]);

  const renderSubmitButton = () => (
    <Button
      variant="primary"
      type="submit"
      disabled={isProcessing}
      className="btn btn-sm"
      role='button'
      aria-label={isUpdate ? 'Update ': 'Save'}
    >
      {isUpdate ? 'Update' : 'Save'}
    </Button>
  );

  const renderCancelButton = () => (
    <Button
      type="button"
      variant="link"
      onClick={onCancel}
      disabled={isProcessing}
      className="mr-2 btn btn-sm"
      role='button'
      aria-label='Cancel'
    >
      Cancel
    </Button>
  );

  return (
    <div className="d-block" data-testid="Wrapper-button">
      {reverse ? (
        <>
          {renderSubmitButton()}
          {renderCancelButton()}
        </>
      ) : (
        <>
          {renderCancelButton()}
          {renderSubmitButton()}
        </>
      )}
    </div>
  );
}

ActionButtons.propTypes = propTypes;
ActionButtons.defaultProps = defaultProps;
